import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiZod } from '@/shared/api'
import { type Transcript, TranscriptSchema } from '../model/schema'
import { toTranscript } from './mappers'

export const transcriptKeys = {
  all: ['transcript'] as const,
  detail: (id: string) => [...transcriptKeys.all, id] as const,
}

export function transcriptQueryOptions(id: string) {
  return queryOptions({
    queryKey: transcriptKeys.detail(id),
    queryFn: async (): Promise<Transcript> => {
      const body = await apiGet(`/meetings/${id}/transcript`, apiZod.zTranscriptBody)
      return TranscriptSchema.parse(toTranscript(body))
    },
  })
}
